// extracted by mini-css-extract-plugin
export default {"glitch":"Greeting_glitch__gg1FO","shift":"Greeting_shift__V8JZh"};